export { Ctext } from './Ctext';
export type { CtextProps } from './Ctext';

